import { fetchFromApi } from './api';

export const getPartnerAdminBrands = async (): Promise<GooseApiPartnerAdminBrands> => {
  try {
    const accounts: GooseApiPartnerAdminBrands = await fetchFromApi('/api/admin/brands');
    return accounts;
  } catch (error) {
    console.error('Could not get managed accounts. Aborting', error);
    return { brands: [], missingAccess: [], };
  }
}
